import { Button, Col, Row, Table } from 'antd'
import qs from 'qs'
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { RouteChildrenProps } from "react-router"
import { Link } from 'react-router-dom'
import {
    EcapReportGroupEnum, ReportTypeEnum, ReportStatesEnum
} from '../../../../constants/constants'
import { ROUTE_PATHS } from "../../../../constants/url-config"
import { EcapReportModel } from '../../../../models/ecap-report.model'
import { RAPMModel } from '../../../../models/rapm.model'
import { setTitle } from '../../../../redux/actions/header.action'
import { ECAPService } from '../../../../services/ecap.service'
import { DATE_UTIL } from "../../../../utils/dateUtils"
import i18n from "../../../../utils/i18n"
import UTIL from '../../../../utils/utils'
import { AddIcon } from '../../../atoms/icon'



interface Props extends RouteChildrenProps { }

const EcapReports = (props: Props) => {

    const { t } = useTranslation();
    const [data, setData] = useState<RAPMModel[]>([]);
    const [dataLoading, setDataLoading] = useState(false);
    const type = useRef<ReportTypeEnum>();
    const group = useRef<EcapReportGroupEnum>();
    const dispatch = useDispatch();

    const addNew = () => {
        if (type.current === ReportTypeEnum.Ramp) {
            props.history.push(ROUTE_PATHS.PortfolioRAROCNewReport);
        } else {
            props.history.push(`${ROUTE_PATHS.ECAPNewReport}?type=${type.current}&group=${group.current}`);
        }
    }

    const getRapmReportLink = (record: EcapReportModel) => {
        if (record.submit_state === ReportStatesEnum.Draft ||
            record.submit_state === ReportStatesEnum.Submitting) {
            let url = `${ROUTE_PATHS.PortfolioRAROCNewReport}?id=${record.id}`;

            if (record.process_state) {
                url = url + `&process_state=${record.process_state}`;
            }

            //use job_id to completed process_state
            if (record.job_id) {
                url = url + `&job_id=${record.job_id}`;
            }

            return url;
        }

        return `${ROUTE_PATHS.PortfolioRAROCReportDetails}/${record.id}`
    }

    const getReportLink = (record: EcapReportModel) => {

        if (record.submit_state === ReportStatesEnum.Draft ||
            record.submit_state === ReportStatesEnum.Submitting) {
            let url = `${ROUTE_PATHS.ECAPNewReport}?type=${record.risk_type}&group=${group.current}&id=${record.id}`;

            if (record.process_state) {
                url = url + `&process_state=${record.process_state}`;
            }

            //use job_id to completed process_state
            if (record.job_id) {
                url = url + `&job_id=${record.job_id}`;
            }

            return url;
        }

        return `${ROUTE_PATHS.ECAPReportDetails}/${record.id}?type=${record.risk_type}&group=${group.current}`
    }

    const columns = [
        {
            title: i18n.t("Rapm.lbReportName"),
            dataIndex: 'report_name',
            key: 'report_name',
            render: (text: string, record: EcapReportModel) =>

                <Link className="blue-text"
                    to={record.risk_type === ReportTypeEnum.Ramp ? getRapmReportLink(record) : getReportLink(record)}
                >
                    {record.risk_type === ReportTypeEnum.Ramp ? `FY${record.fiscal_year} - Quarter ${record.quarter}` : `FY${record.fiscal_year} - ${UTIL.getECapReportTypeDisplay(record.risk_type)}`}
                </Link >
        },
        {
            title: i18n.t("Rapm.lbReportOwner"),
            dataIndex: 'created_by',
            key: 'created_by',
        },
        {
            title: i18n.t("Rapm.lbStatus"),
            dataIndex: 'submit_state',
            key: 'submit_state',
            render: (text: string) => {
                const dom = UTIL.getLossStatesDOM(text);
                return (<span style={{ color: dom.color }}>
                    {dom.text}
                </span>)
            }
        },
        {
            title: i18n.t("Rapm.lbDateCreated"),
            dataIndex: 'created_on',
            key: 'created_on',
            render: (date: string) => DATE_UTIL.convertServerToViewFormat(date)
        },
        {
            title: i18n.t("Rapm.lbDueDate"),
            dataIndex: 'due_date',
            key: 'due_date',
            render: (date: string) => DATE_UTIL.convertServerToViewFormat(date)
        }
    ];

    const getData = () => {
        setDataLoading(true);
        ECAPService.getEcapReports(type.current).then(res => {
            setData(res.data);
        }).finally(() => setDataLoading(false));
    }

    useEffect(() => {
        if (props.location.pathname === ROUTE_PATHS.PortfolioRAROCModule) {
            type.current = ReportTypeEnum.Ramp;
        } else {
            const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });
            type.current = query.type as ReportTypeEnum;
            group.current = Number(query.group) as EcapReportGroupEnum;
            dispatch(setTitle(UTIL.getECapReportTypeDisplay(type.current)));
        }


        if (!Object.values(ReportTypeEnum).includes(type.current)) {
            props.history.push(ROUTE_PATHS.Home); // navigate 404 page
        } else {
            getData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.search])

    return (
        <div className='control-failure-wrapper'>
            <Row className="header-page">
                <Col sm={12}>
                    <h4>
                        {t("Rapm.listTitle")}
                    </h4>
                </Col>
                <Col sm={12} className='action-box'>
                    <Button type="primary" shape="round" onClick={addNew}>
                        <AddIcon className="btn-icon" /> {t("Rapm.btnAdd")}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Table
                        loading={dataLoading}
                        dataSource={data}
                        columns={columns} rowKey="id" />
                </Col>
            </Row>
        </div>
    )
}

export default EcapReports;